import React, { Component } from 'react';
import './style.scss';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import store from 'client/store';
import ExternalLink from 'helpers/externalLink';

@observer
class AdditionalBanner extends Component {
	render() {
		const { banner } = this.props;
		return (
			<div className='additional-banner-container'>
				<div className='additional-banner-image'>
					{banner.image ? (
						<img src={banner.downloadFile('image')} alt={banner.header} />
					) : (
						<div className='empty' style={{ background: banner?.colorBackground }}></div>
					)}
				</div>
				<div className='header-description-button-container'>
					<div className='additional-banner-header' style={{ color: banner.colorText }}>
						{banner.header}
					</div>
					<div className='additional-banner-description' style={{ color: banner.colorText }}>
						{banner.description}
					</div>
					<ExternalLink to={banner.linkButton} alt={banner.textButton}>
						<button className='additional-banner-button' style={{ color: banner.colorTextButton, background: banner.colorButton }}>
							{banner.textButton}
						</button>
					</ExternalLink>
				</div>
			</div>
		);
	}
}

export default AdditionalBanner;
